import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

document.addEventListener('DOMContentLoaded', function () {
    if (!document.body.classList.contains('animate-active')) {
        return
    }

    let start

    gsap.utils.toArray('.animate-el').forEach((animateEl, i) => {
        if (window.innerWidth < 768) {
            start = 10 + i * 2 //
        } else if (window.innerWidth < 1024) {
            start = 20 + i * 2 //
        } else {
            start = 50 + i * 2 //
        }

        ScrollTrigger.create({
            trigger: animateEl,
            start: '+=' + start + 'px bottom',
            onEnter: () => {
                animateEl.classList.add('active')
            },
        })
    })
})
